import { random, round2Str, formatDateTime } from "../helpers/helpers";

export const generate_outdoor_line_chart_demo = ({ start, end }) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const now = new Date();

    const chart_data = [];

    let current = new Date(startDate);
    current.setHours(0, 0, 0, 0);

    while (current <= endDate && current <= now) {
        // every 2 minutes (realistic dense AQI)
        for (let i = 0; i < 30; i++) {
            const d = new Date(current.getTime() + i * 2 * 60 * 1000);
            if (d > now) break;

            chart_data.push({
                device_time: formatDateTime(d),
                aqi: Math.round(random(250, 280)),
                co: round2Str(random(900, 1300)),
                co_monoxide: "0.00",
                formaldehyde: "13.00",
                humidity: round2Str(random(45, 55)),
                no2: "0.00",
                o3: "0.00",
                pm10: round2Str(random(55, 70)),
                pm2: round2Str(random(52, 68)),
                smoke: round2Str(random(1100, 1300)),
                so2: "0.00",
                temperature: round2Str(random(27.5, 29.5)),
                tvoc: round2Str(random(2200, 2600)),
            });
        }

        current.setDate(current.getDate() + 1);
    }

    return {
        chart_data,
        is_co: true,
        is_co_monoxide: true,
        is_formaldehyde: true,
        is_humidity: true,
        is_no2: true,
        is_o3: true,
        is_pm10: true,
        is_pm2: true,
        is_smoke: true,
        is_so2: true,
        is_temperature: true,
        is_tvoc: true,
    };
};